import React from 'react';
import PropTypes from 'prop-types';
import CircleButton from './CircleButton';

function Option({
  label, onSelect, title, description, image,
}) {
  if (title) {
    return (
      <div>
        <CircleButton label={label} onSelect={onSelect} />
        <div className="mb-1">
          <strong>{title}</strong>
        </div>
        <div>
          <p>{description}</p>
        </div>
      </div>
    );
  }
  if (image) {
    return (
      <div>
        <div>
          <img className="img-fluid" src={image} alt="option" />
        </div>
        <div className="d-flex justify-content-center">
          <CircleButton label={label} onSelect={onSelect} />
        </div>
      </div>
    );
  }
  return (
    <p className="danger">
      could not load option to select, please try again or contact support
    </p>
  );
}

Option.propTypes = {
  label: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
};

Option.defaultProps = {
  title: null,
  description: null,
  image: null,
};

export default Option;
